const routes = [
  {
    path: '/energyConsumeManage',
    name: 'energyConsumeManage',
    component: () => import('./pages/Home'),
    meta: {
      requireAuth: false
    },
    children: [
      {
        path: 'alarm', // 能耗告警
        name: 'alarm',
        component: () => import('./pages/Alarm'),
        meta: {
          requireAuth: false,
          routerAlive: true
        }
      },
      {
        path: 'forewarning', // 能耗预警
        name: 'forewarning',
        component: () => import('./pages/ForeWarning'),
        meta: {
          requireAuth: false,
          routerAlive: true
        }
      },
      {
        path: 'waterRecord', // 用水记录
        name: 'waterRecord',
        component: () => import('./pages/waterRecord'),
        meta: {
          requireAuth: false,
          routerAlive: true
        }
      },
      {
        path: 'meterIndicator', // 水电表指标
        name: 'meterIndicator',
        component: () => import('./pages/MeterIndicator'),
        meta: {
          requireAuth: false,
          routerAlive: true
        }
      },
      {
        path: 'guFengPingWarning', // 谷峰平预警
        name: 'guFengPingWarning',
        component: () => import('./pages/GuFengPingWarning'),
        meta: {
          requireAuth: false,
          routerAlive: true
        }
      },
      {
        path: 'display', // 能耗显示
        name: 'display',
        component: () => import('./pages/Display'),
        meta: {
          requireAuth: false,
          routerAlive: false
        }
      },
    ]
  }
]

export default routes